import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { purchaseNotifications } from '../data/content';
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId = 0;
    const cycle = () => {
      setVisible(true);
      timeoutId = window.setTimeout(() => {
        setVisible(false);
        setIndex(prev => (prev + 1) % purchaseNotifications.length);
        timeoutId = window.setTimeout(cycle, 9000);
      }, 6000);
    };
    timeoutId = window.setTimeout(cycle, 7000);
    return () => window.clearTimeout(timeoutId);
  }, [dismissed, index]);
  if (dismissed) return null;
  const item = purchaseNotifications[index];
  const minutesAgo = 2 + index % 7;
  return <AnimatePresence data-id="element-210" data-mp="1gydysahv77o7">
      {visible && <motion.aside initial={{
      x: -20,
      y: 16,
      opacity: 0
    }} animate={{
      x: 0,
      y: 0,
      opacity: 1
    }} exit={{
      x: -20,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 28
    }} aria-live="polite" className="fixed bottom-24 left-3 right-3 z-40 sm:right-auto sm:bottom-28 sm:max-w-xs" data-id="element-211" data-mp="165pka9e6cobd">
          <div className="relative flex items-start gap-3 rounded-xl border border-navy-100 bg-white p-3 pr-8 shadow-lift" data-id="element-212" data-mp="1ayshcri5ufwb">
            <span className="mt-0.5 flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-teal-light" data-id="element-213" data-mp="i8a4wzvjr268">
              <CheckCircle2Icon className="h-5 w-5 text-teal" aria-hidden="true" data-id="element-214" data-mp="x5krb49q9sgq" />
            </span>
            <div className="min-w-0" data-id="element-215" data-mp="s4wsvxj669ch">
              <p className="text-[13px] font-bold leading-snug text-navy-900" data-id="element-216" data-mp="28k7tgzg5yqmm">
                {item.name} de {item.city}, {item.country}
              </p>
              <p className="text-[12.5px] leading-snug text-navy-700/80" data-id="element-217" data-mp="23l3ji6lf0ov8">
                acaba de comprar la <strong data-id="element-218" data-mp="2aobempxl44xk">Ruta Clínica GLP-1™</strong>
              </p>
              <p className="mt-1 text-[11px] font-semibold uppercase tracking-wide text-navy-400" data-id="element-219" data-mp="2fmmoh0nvqffs">
                Hace {minutesAgo} minutos
              </p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute right-2 top-2 rounded-md p-1 text-navy-400 transition-colors hover:bg-navy-50 hover:text-navy-700" data-id="element-220" data-mp="2plkd03lb28ys">
              <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-221" data-mp="21wj8grflfhys" />
            </button>
          </div>
        </motion.aside>}
    </AnimatePresence>;
}